const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const environment = {
    baseUrl: isLocalhost
      ? (window.__API_BASE__ || process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000')
      : (window.__API_BASE__ || ''),
    // Same-origin proxy URL for large uploads (avoids Safari cross-origin limits)
    uploadUrl: isLocalhost
      ? (window.__API_BASE__ || process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000')
      : ''
}
